module.exports = __webpack_public_path__ + "static/media/blue_rust.ecf56c2b.jpg";